import React from 'react';
import PhotoViewer from '../../common/photo/PhotoViewer';

const Gallery = () => {
  return (
    <div className="content-block bg-light p-3 rounded">
      {/* Activate the gender filter explicitly for the Gallery */}
      <PhotoViewer title="Gallery" showGenderFilter={true} />
    </div>
  );
};

export default Gallery;